export default __webpack_public_path__ + "static/media/10.27a5bad7.jpg";